import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/joy';
import { useAuth } from '../context/AuthContext';

const Navigation = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <Box
      sx={{
        backgroundColor: '#eb7a24',
        padding: '1rem 2rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}
    >
      <Typography level="h3" sx={{ color: 'white', fontWeight: 'bold' }}>
        Dental Stock
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        <Button
          component={Link}
          to="/stock"
          variant="plain"
          sx={{
            color: 'white',
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' }
          }}
        >
          Materials
        </Button>
        <Button
          component={Link}
          to="/disposables"
          variant="plain"
          sx={{
            color: 'white',
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' }
          }}
        >
          Disposables
        </Button>
        <Button
          component={Link}
          to="/implants"
          variant="plain"
          sx={{
            color: 'white',
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' }
          }}
        >
          Implants
        </Button>
        <Button
          component={Link}
          to="/add-item"
          variant="plain"
          sx={{
            color: 'white',
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' }
          }}
        >
          Add Stock
        </Button>
        <Button
          component={Link}
          to="/vendors"
          variant="plain"
          sx={{
            color: 'white',
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' }
          }}
        >
          Vendors
        </Button>
        <Button
          onClick={handleLogout}
          variant="outlined"
          sx={{
            color: 'white',
            borderColor: 'white',
            '&:hover': {
              backgroundColor: 'rgba(255,255,255,0.2)',
              borderColor: 'white'
            }
          }}
        >
          Logout
        </Button>
      </Box>
    </Box>
  );
};

export default Navigation;

